import { Button } from "semantic-ui-react";

export default Button;
